import { useParams } from 'react-router-dom';
import classNames from 'classnames';

import defaultStyles from '../../styles/formSetStyles.module.css';
import formStyles from '../FormStart/index.module.css';
import styles from './index.module.css';
import NavBar, { View } from '../../components/NavBar';
import LoadingBar from '../../components/LoadingBar';

import { AppointmentsListView } from './AppointmentsListView';
import { AppointmentsConfirmationView } from './AppointmentsConfirmationView';
import { useTheme } from '../../hooks/common/useTheme';
import { useAppointments } from '../../hooks/appointment/useAppointments';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';

import * as api from '../../api';

export const ConfirmAppointmentScene: React.FC = () => {
  const { t } = useTranslation();
  const { authenticationCode } = useParams<{ authenticationCode: string }>();
  const { isThemeLoading } = useTheme({ authCode: authenticationCode });
  const {
    isLoading,
    appointments,
    appointmentsConfirmed,
    appointmentsToConfirm,
    onReplySubmit,
    isSubmitting,
    onConfirmed,
    getAppointments,
    anyReschedulable,
    skipConfirmationScreen,
  } = useAppointments(authenticationCode);

  useEffect(() => {
    api.client.Previsit.createPrevisitLog({
      auditLog:
        api.Log.PrevisitAuditAction.PatientPrevisitNavigatedToConfirmCancelPage,
      previsitLog: api.Log.PrevisitAction.NavigatedToConfirmCancelPage,
      authenticationCode,
    });
  }, [authenticationCode]);

  if (isLoading || isThemeLoading) {
    return (
      <div className={styles.LoadingBarContainer}>
        <LoadingBar />
      </div>
    );
  }
  const renderBody = () => {
    if (!appointments)
      return (
        <div className={classNames(defaultStyles.Label, styles.Label)}>
          {t('Something went wrong, please try again later.')}
        </div>
      );
    if (appointments.length === 0) {
      return (
        <div className={classNames(defaultStyles.Label, styles.Label)}>
          {t('There are no future appointments available for this week.')}
        </div>
      );
    }
    if (appointmentsToConfirm?.length) {
      return (
        <AppointmentsListView
          appointments={appointmentsToConfirm}
          onAppointmentsReply={onReplySubmit}
          pending={isSubmitting}
          getAppointments={getAppointments}
          anyReschedulable={anyReschedulable}
          onConfirmed={onConfirmed}
          skipConfirmationScreen={skipConfirmationScreen}
        />
      );
    }

    return (
      <AppointmentsConfirmationView
        appointmentsConfirmed={appointmentsConfirmed}
        onConfirmed={onConfirmed}
      />
    );
  };

  return (
    <>
      <NavBar view={View.Login} />
      <div className={formStyles.FormContainer}>
        <div className={formStyles.Form}>
          <div>{renderBody()}</div>
        </div>
      </div>
    </>
  );
};
